import { render, staticRenderFns } from "./MainCompressionForce.vue?vue&type=template&id=21ed2cc4&scoped=true&"
import script from "./MainCompressionForce.vue?vue&type=script&lang=ts&"
export * from "./MainCompressionForce.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ed2cc4",
  null
  
)

export default component.exports